import forge from 'node-forge'

export const rsaEncrypt = (rsa_key: string, data_to_encrypt: string) => {
    const public_Key = forge.pki.publicKeyFromPem(rsa_key)
    return forge.util.encode64(public_Key.encrypt(data_to_encrypt))
}
